import CancelIcon from "@mui/icons-material/Cancel";
import EmailIcon from "@mui/icons-material/Email";
import PaidIcon from "@mui/icons-material/Paid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { PermissionActionsEnum, PermissionRolesEnum } from "../../../../shared/enums/profiles";
import { checkByProfileGuard } from "../../../../shared/guards/ProfileGuard";
import { ISetup } from "../../../../shared/services/api/financial/FinancialService";

export type SetupMenuModalType = "details" | "cancel" | "resendEmail" | "manualPayment" | "clientPayment";

interface SetupMenuProps {
	anchorEl: null | HTMLElement;
	open: boolean;
	onClose: () => void;
	selectedRow: ISetup | null;
	onOpenModal: (type: SetupMenuModalType, row: ISetup) => void;
}

export const SetupMenu = ({ anchorEl, open, onClose, selectedRow, onOpenModal }: SetupMenuProps) => {
	if (!selectedRow) return null;

	const canManualPayment = selectedRow.status === "pending";
	const canCancel = selectedRow.status === "pending";
	const canResendEmail = selectedRow.status === "pending";
	const canClientPayment = selectedRow.status === "paid";
	const canView = checkByProfileGuard(PermissionRolesEnum.FinancialOptions, PermissionActionsEnum.View);
	const canUpdate = checkByProfileGuard(PermissionRolesEnum.FinancialOptions, PermissionActionsEnum.Update);
	const canAdd = checkByProfileGuard(PermissionRolesEnum.FinancialOptions, PermissionActionsEnum.Add);

	return (
		<Menu anchorEl={anchorEl} open={open} onClose={onClose}>
			{canView && (
				<MenuItem
					onClick={() => {
						onClose();
						onOpenModal("details", selectedRow);
					}}
				>
					<ListItemIcon>
						<VisibilityIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText primary="Visualizar detalhes" />
				</MenuItem>
			)}

			<Divider />

			{canAdd && (
				<MenuItem
					onClick={() => {
						onClose();
						onOpenModal("resendEmail", selectedRow);
					}}
					disabled={!canResendEmail}
				>
					<ListItemIcon>
						<EmailIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText primary="Reenviar e-mail" />
				</MenuItem>
			)}

			{canUpdate && (
				<MenuItem
					onClick={() => {
						if (!canManualPayment) return;
						onClose();
						onOpenModal("manualPayment", selectedRow);
					}}
					disabled={!canManualPayment}
				>
					<ListItemIcon>
						<PaidIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText primary="Baixa manual" />
				</MenuItem>
			)}

			{canAdd && (
				<MenuItem
					onClick={() => {
						onClose();
						onOpenModal("clientPayment", selectedRow);
					}}
					disabled={!canClientPayment}
				>
					<ListItemIcon>
						<PaidIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText primary="Repasse imobiliária" />
				</MenuItem>
			)}

			<Divider />

			{canAdd && (
				<MenuItem
					onClick={() => {
						if (!canCancel) return;
						onClose();
						onOpenModal("cancel", selectedRow);
					}}
					disabled={!canCancel}
				>
					<ListItemIcon>
						<CancelIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText primary="Cancelar" />
				</MenuItem>
			)}
		</Menu>
	);
};
